import { RouteHelpers } from '@/mixins';
import { Common } from '@/types';

const ErrorPage = () => import(/* webpackChunkName: "ErrorPage" */ '@/views/shared/ErrorPage.vue');
const AboutPage = () => import(/* webpackChunkName: "About" */ '@/views/About.vue');
const UserPreferences = () => import(/* webpackChunkName: "About" */ '@/views/UserPreferences.vue');
const WelcomeRedirect = () => import(/* webpackChunkName: "WelcomeRedirect" */ '@/components/shared/WelcomeRedirect.vue');

export const CommonRoutes = [
  {
    ...Common.About,
    meta: {
      title: 'About'
    },
    component: AboutPage
  },
  {
    ...Common.Error,
    component: ErrorPage,
    meta: {
      title: 'Error'
    },
    props: true,
    beforeEnter: RouteHelpers.beforeEnterCheckthePropsForErrorPage
  },
  {
    ...Common.PageNotFound,
    component: ErrorPage,
    meta: {
      title: 'Not Found'
    },
    props: {
      errorCode: 404,
      errorMessage: 'Page Not Found'
    }
  },
  {
    ...Common.Welcome,
    meta: {
      title: 'Welcome'
    },
    component: WelcomeRedirect
  },
  {
    ...Common.UserPreferences,
    meta: {
      title: 'User Preferences'
    },
    component: UserPreferences
  }
];
